import React, { Fragment } from 'react';
import ArticleHeaderSkeleton from 'components/general/ArticleHeader/ArticleHeaderSkeleton';
import SkeletonParagraph from 'components/general/Skeleton/SkeletonParagraph';

const MatrixSetSkeleton = () => (
  <Fragment>
    <div className="block block--restrict">
      <ArticleHeaderSkeleton />
    </div>
    <div className="block block--restrict">
      <SkeletonParagraph lines={6} />
    </div>
  </Fragment>
);

export default MatrixSetSkeleton;

